import React from 'react';
import IDigestLogo from '../../img/splash0.png';
import { Button, Input, Label, Link, Text, useId } from '@fluentui/react-components';
import { mergeStyleSets } from '@fluentui/react';
import { sharedStyles, styles as WelcomeStyles } from './index';
import { useTranslation } from 'react-i18next';
import { _dataProvider } from '../../dataProvider/DataProvider';
import useRequestButton from './hooks/useRequestButton';

export type ILoginProps = {
  onLoginSuccess?: () => void;
  onGoToRegister?: () => void;
  onGoToForgetPwd?: () => void;
};

const Login: React.FC<ILoginProps> = (props) => {
  const { onLoginSuccess, onGoToRegister, onGoToForgetPwd } = props;
  const { t } = useTranslation();
  const inputEmailId = useId('email');
  const inputPasswordId = useId('password');

  const { loadingState, setLoadingState, buttonIcon } = useRequestButton();

  const handleSubmit = async (evt: React.FormEvent) => {
    if (loadingState !== 'initial') {
      return;
    }

    evt.preventDefault();
    const form = evt.target as HTMLFormElement;
    const formData = Object.fromEntries(new FormData(form).entries());

    console.log('Login Form Data:', formData);
    const { email, password } = formData as Record<'email' | 'password', string>;

    setLoadingState('loading');
    const isSuccess = await login({ loginId: email, password });
    if (isSuccess) {
      setTimeout(() => {
        onLoginSuccess?.();
      }, 500);
    }
    setLoadingState(isSuccess ? 'loaded' : 'initial');
  };

  const login = async ({ loginId, password }: { loginId: string; password: string }) => {
    try {
      const { success, error } = (await _dataProvider.signIn(loginId, password)) ?? {};

      if (!success) {
        throw new Error(error);
      }

      return true;
    } catch (err) {
      console.log('login error:', err);
      alert(err);
    }

    return false;
  };

  return (
    <div className={sharedStyles.container}>
      <Text as='h3' block className={WelcomeStyles.subTitle}>
        {t('welcome.login.title')}
      </Text>
      <Text block className={styles.description}>
        {t('welcome.login.description1')}
        <img height={20} src={IDigestLogo} style={{ verticalAlign: 'middle' }} />
        {t('welcome.login.description2')}
      </Text>

      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles['form-item']}>
          <Label htmlFor={inputEmailId}>{t('Email')}</Label>
          <Input
            className={styles['form-ctrl']}
            size='large'
            id={inputEmailId}
            placeholder={t('example')}
            required
            name='email'
          />
        </div>
        <div className={styles['form-item']}>
          <Label htmlFor={inputPasswordId}>{t('pwd')}</Label>
          <Input
            className={styles['form-ctrl']}
            size='large'
            type='password'
            id={inputPasswordId}
            required
            name='password'
          />
          <Link style={{ color: '#FF9900', textAlign: 'center' }} onClick={onGoToForgetPwd}>
            {t('ForgotPassword')}
          </Link>
        </div>
        <div className={styles['form-item']}>
          <Button className={styles.primaryButton} type='submit' appearance='secondary' size='large' icon={buttonIcon}>
            {t('login')}
          </Button>
          <Link style={{ color: '#FF9900', textAlign: 'center' }} onClick={onGoToRegister}>
            {t('welcome.login.createNewUser')}
          </Link>
        </div>
      </form>
    </div>
  );
};

export default Login;

const styles = mergeStyleSets({
  description: {
    whiteSpace: 'nowrap !important'
  },

  form: {},

  ['form-item']: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    gap: '4px',
    marginTop: '24px',
    alignItems: 'center',
    '& label': {
      fontWeight: 'bold'
    }
  },

  ['form-ctrl']: {
    width: '100%',
    overflow: 'hidden'
  },

  primaryButton: {
    marginTop: '64px !important',
    width: '192px'
  }
});
